export default {
    label_task:{
        en:"Distributors Business Plan",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Distributor Business Plan",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Distributor Business Plan",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Distributor Business Plan",
        bn:'ব্যবহারকারীর বিবরণ'
    },

    label_sales_at:{
        en:"Sales Time",
        bn:"কর্মচারী আইডি"
    },
    label_invoice_no:{
        en:"Invoice No",
        bn:"কর্মচারী আইডি"
    },
    label_total_type_entered:{
        en:"# of types data",
        bn:"কর্মচারী আইডি"
    },

    label_month_start :{
        en:"Start Month",
        bn:'ব্যবহারকারীরা'
    },
    label_month_end :{
        en:"End Month",
        bn:'ব্যবহারকারীরা'
    },
    label_pocket_market :{
        en:"Pocket Market",
        bn:'ব্যবহারকারীরা'
    },
    label_distributor_recommendation :{
        en:"Distributor Recommendation",
        bn:'ব্যবহারকারীরা'
    },
    label_manager_recommendation :{
        en:"Managers Recommendation",
        bn:'ব্যবহারকারীরা'
    },
    label_manager_suggestion :{
        en:"Managers Suggestion",
        bn:'ব্যবহারকারীরা'
    },
    label_forecast :{
        en:"Forecast",
        bn:'ব্যবহারকারীরা'
    },
    label_dealer_meeting :{
        en:"# of Dealer Meeting ",
        bn:'ব্যবহারকারীরা'
    },
    label_farmer_meeting :{
        en:"# of Farmer Meeting",
        bn:'ব্যবহারকারীরা'
    },
    label_num_demo :{
        en:"# of Demo",
        bn:'ব্যবহারকারীরা'
    },
    label_num_result_sharing :{
        en:"# of Result Sharing",
        bn:'ব্যবহারকারীরা'
    },
    label_num_field_day :{
        en:"# of Field Day",
        bn:'ব্যবহারকারীরা'
    },

}